import React from 'react';
import { Panel } from 'govuk-react-jsx/govuk/components/panel';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';
import { useResetReduxState } from '../../hooks/useResetReduxState';

const PrpAccountSubmited = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.PrpAccountSubmitted.s6',
    'You have submitted your account details - OZEV Electric Vehicle Chargepoint Grants - GOV.UK'
  );

  useResetReduxState('registrationJourney');
  const panelHeading = copyProvider.getCopy(
    'landlordReg.PrpAccountSubmitted.s1',
    'You have submitted your account details'
  );
  const paragraph = copyProvider.getCopy(
    'landlordReg.PrpAccountSubmitted.s2',
    'You will not be able to sign in to your account until we verify your details. We will send you an email when your account is ready. This usually takes 5 working days.'
  );
  const subHeading = copyProvider.getCopy(
    'landlordReg.PrpAccountSubmitted.s3',
    'Help to make this service better'
  );
  const pageModel = (
    <>
      <Panel titleChildren={panelHeading} />
      <p className="govuk-body">{paragraph}</p>
      <h2 className="govuk-heading-s">{subHeading}</h2>
      <p className="govuk-body">
        <a
          href="https://www.smartsurvey.co.uk/s/EV-grants/"
          rel="noopener noreferrer"
          className="govuk-link"
        >
          {copyProvider.getCopy(
            'landlordReg.PrpAccountSubmitted.s4',
            'What did you think of this service?'
          )}
        </a>
        {copyProvider.getCopy(
          'landlordReg.PrpAccountSubmitted.s5',
          ' (takes 30 seconds)'
        )}
      </p>
    </>
  );
  return pageModel;
};

export default PrpAccountSubmited;
